var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrafficLight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m168 40h176v400h-176z",
    fill: "#3e3d42"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 240,
    fill: "#ffda44",
    r: 48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 112,
    fill: "#d80027",
    r: 48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 368,
    fill: "#91cc04",
    r: 48
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#2d2d30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m220 16h72a20 20 0 0 1 20 20v4a0 0 0 0 1 0 0h-112a0 0 0 0 1 0 0v-4a20 20 0 0 1 20-20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m224 440h64v56h-64z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m368 160h-24v-96h40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m368 296h-24v-96h40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m368 424h-24v-96h40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m144 160h24v-96h-40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m144 296h24v-96h-40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m144 424h24v-96h-40z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256 184a56 56 0 1 0 56 56 56.063 56.063 0 0 0 -56-56zm0 96a40 40 0 1 1 40-40 40.045 40.045 0 0 1 -40 40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 56a56 56 0 1 0 56 56 56.063 56.063 0 0 0 -56-56zm0 96a40 40 0 1 1 40-40 40.045 40.045 0 0 1 -40 40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 312a56 56 0 1 0 56 56 56.063 56.063 0 0 0 -56-56zm0 96a40 40 0 1 1 40-40 40.045 40.045 0 0 1 -40 40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m368 304a8 8 0 0 0 7.89-6.68l16-96a8.007 8.007 0 0 0 -7.89-9.32h-32v-24h16a8 8 0 0 0 7.89-6.68l16-96a8.007 8.007 0 0 0 -7.89-9.32h-32v-16a8 8 0 0 0 -8-8h-24.29a28.043 28.043 0 0 0 -27.71-24h-72a28.043 28.043 0 0 0 -27.71 24h-24.29a8 8 0 0 0 -8 8v16h-32a8.007 8.007 0 0 0 -7.89 9.32l16 96a8 8 0 0 0 7.89 6.68h16v24h-32a8.007 8.007 0 0 0 -7.89 9.32l16 96a8 8 0 0 0 7.89 6.68h16v16h-32a8.007 8.007 0 0 0 -7.89 9.32l16 96a8 8 0 0 0 7.89 6.68h16v8a8 8 0 0 0 8 8h48v48a8 8 0 0 0 8 8h64a8 8 0 0 0 8-8v-48h48a8 8 0 0 0 8-8v-8h16a8 8 0 0 0 7.89-6.68l16-96a8.007 8.007 0 0 0 -7.89-9.32h-32v-16zm-16-232h22.56l-13.34 80h-9.22zm0 136h22.56l-13.34 80h-9.22zm-192 208h-9.22l-13.34-80h22.56zm0-128h-9.22l-13.34-80h22.56zm0-136h-9.22l-13.34-80h22.56zm60-128h72a12.014 12.014 0 0 1 11.31 8h-94.62a12.014 12.014 0 0 1 11.31-8zm60 464h-48v-40h48zm56-56h-160v-384h160zm38.56-96-13.34 80h-9.22v-80z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrafficLight);
export default __webpack_public_path__ + "static/media/traffic-light.e2384f32e3379b334172e90ed988c333.svg";
export { ForwardRef as ReactComponent };